<template>
  <div class="30daysfree">

    <div class="container"  >

  <v-card>
    <v-toolbar
      flat
      color="primary"
      dark
      class="m4u_text--text"
    >
      <v-toolbar-title>Earn a 5$ Amazon gift card!</v-toolbar-title>
    </v-toolbar>
    <v-tabs vertical>
      <v-tab>
        <v-icon left>
          mdi-share-variant
        </v-icon>
      </v-tab>
      <v-tab>
        <v-icon left>
          mdi-connection
        </v-icon>
      </v-tab>
      <v-tab>
        <v-icon left>
          mdi-head-question-outline
        </v-icon>
      </v-tab>

      <v-tab-item>
        <v-card flat >
          <v-card-text >
            <p class="freeHeading m4u_text--text">
                When your friend signs up for a paid account, you will receive a $5 Amazon gift card emailed to your registered email address.
            </p>

            <p class="mb-0">
                   <v-form v-model="valid" ref="form" lazy-validation>
    <v-container>
      <v-card >
        <v-card-text class="m4u_tertiary">
      <h3 class="m4u_text--text m4u_tertiary">Who do you want to invite?</h3>
      <v-row class="m4u_tertiary">
        <v-col
          cols="12"
          md="6"
        >
          <v-text-field
            v-model="invitee"
            :rules="nameRules"
            :counter="50"
            label="Name"
            required
            color="m4u_text"
          ></v-text-field>
        </v-col>

        <v-col
          cols="12"
          md="6"
        >
          <v-text-field
            v-model="email"
            :rules="emailRules"
            label="E-mail"
            required
            color="m4u_text"
          ></v-text-field>
        </v-col>
      </v-row>
      {{message}}
      </v-card-text>
      <v-btn class="primary mt-5 mb-2 ml-3 m4u_text--text" @click="sendInvitation()">Invite</v-btn>
      </v-card>
    </v-container>
  </v-form>
            </p>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat >
          <v-card-text>
            <p class="freeHeading m4u_text--text">
              If we use your QuickConnect suggestion, you'll get a $5 Amazon gift card!
            </p>

            <p class="mb-0">

      <v-row class="m4u_tertiary">
          <v-text-field
            v-model="qcSuggestion"
            label="Your QuickConnect suggestion"
            required
            counter
            color="m4u_text"
            maxlength="200"
            @keypress="qcMessage = ''"
          ></v-text-field>
      </v-row>
        {{qcMessage}}

      <v-btn class="primary mt-5 mb-2 ml-3 m4u_text--text" @click="sendQC()">Send</v-btn>
            </p>
          </v-card-text>
<v-dialog
      v-model="qcdialog"
      width="500"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
        class="teal--text text--accent-4"
        text
        small
          v-bind="attrs"
          v-on="on"
        >
           See Details
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="m4u_text--text">
          Policy
        </v-card-title>

        <v-card-text>
            *Suggestions for QuickConnect questions will be rewarded to the first user to submit a question we use. Suggestions that are substantially similar will not count as a new question. 
StoriesForUs reserves the right to determine which questions are alike and which questions will be used. Gift cards will be emailed to your registered email address.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
           class="teal--text text--accent-4"
            text
            @click="qcdialog = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat >
          <v-card-text>
            <p class="freeHeading m4u_text--text">
              If we use your interview question suggestion, you'll get a $5 Amazon gift card!
            </p>

            <p class="mb-0">

      <v-row class="m4u_tertiary">
          <v-text-field
            v-model="interviewQuestion"
            label="Your Inteview Question"
            required
            counter
            color="m4u_text"
            maxlength="200"
            @keypress="interviewMessage = ''"
          ></v-text-field>
      </v-row>
    {{interviewMessage}}
      <v-btn class="primary mt-5 mb-2 ml-3 m4u_text--text" @click="sendInterview()">Send</v-btn>
            </p>
          </v-card-text>
              <v-dialog
      v-model="interviewdialog"
      width="500"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
        text
        small
        class="teal--text text--accent-4"
          v-bind="attrs"
          v-on="on"
        >
           See Details
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="m4u_text--text">
          Policy
        </v-card-title>

        <v-card-text>
            *Suggestions for Interview questions will be rewarded to the first user to submit a question we use. Suggestions that are substantially similar will not count as a new question. 
StoriesForUs reserves the right to determine which questions are alike and which questions will be used. Gift cards will be emailed to your registered email address.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="teal--text text--accent-4"
            text
            @click="interviewdialog = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </v-card>
    </div>
  </div>
</template>

<script>

import EventService from '@/services/EventService.js'; 

export default {
  name: 'CharterSuggestions',

 data() {
    return {
        tcMonth: '',
        tcDay: '',
        tcYear: '',
        tcDate: '',
        valid: false,
      invitee: '',
      nameRules: [
        v => !!v || 'Name is required',
        v => v.length <= 15 || 'Name must be less than 10 characters',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid',
      ],
      message: '',
      qcSuggestion: '',
      qcMessage: '',
      interviewQuestion: '',
      interviewMessage: '',
      qcdialog: false,
      interviewdialog: false
    };
  },

  mounted() {
    this.setUpDate();
  },

  computed: {
  user(){
    return this.$store.state.user
  },

    loginState(){
    return this.$store.state.loginState
  },

},

  methods: {
      async sendInvitation() {
        this.message = '';
      await EventService.sendInvitation(this.user.UserID, this.invitee, this.email, this.tcDate, this.user.UserDisplayName, 1)
      .then(
        (invitationreturn => {
          if(invitationreturn.data === 'Duplicate'){
            this.message = 'You have already invited this person.'
          } else if (invitationreturn.data === 'Member') {
            this.message = 'This person already has an account. You can invite them to your circles.'
          }
          else {
            this.message = 'Your invitation to ' + this.invitee + ' has been sent.';
            this.invitee = '';
            this.email = '';
            this.$refs.form.reset();
            this.$refs.form.resetValidation();
          }
        })
      )
      .then((sendInvitationReturn) => {
      });
    },

    async setUpDate() {
      var dateObj = new Date();
      this.tcMonth = dateObj.getUTCMonth() + 1; //months from 1-12
      if(this.tcMonth <10)  { this.tcMonth ='0'+ this.tcMonth } 
      this.tcDay = dateObj.getUTCDate();
       if(this.tcDay <10)  { this.tcDay ='0'+ this.tcDay } 
      this.tcYear = dateObj.getUTCFullYear();
      this.tcDate = this.tcYear + "-" + this.tcMonth + "-" + this.tcDay; 
    },

    async sendQC() {
      await EventService.sendQCSuggestion(this.user.UserID, this.qcSuggestion)
      .then((result) => {
          if (result === 'success') {
              this.qcSuggestion = '';
              this.qcMessage = 'Suggestion sent'
          }
          else {
              this.qcMessage = 'Error'
          }
      })
    },

    async sendInterview() {
      await EventService.sendInterviewSuggestion(this.user.UserID, this.interviewQuestion)
      .then((result) => {
          if (result === 'success') {
              this.interviewQuestion = '';
              this.interviewMessage = 'Suggestion sent';
          }
          else {
              this.interviewMessage = 'Error'
          }
      })
    },    
  }


}
</script>
<style lang="scss" scoped>

 .finePrint {
     font-size: .75em
 }
 .formCard {
    max-width: 90%;
    justify-content: center;
  }

  .pageHeading {
    font-size: 1.25em;
  }

  .pageSubHeading {
    font-size: 1em;
  }

  .toggleButtons {
    margin-bottom: 1em;
    margin-top: 1.25em;

  }

  .outerDiv {
    background-color: white;
  }

 .warningtext {
   font-size: 1.25em;
 }
</style>